import * as React from 'react';
import { useController, useFormContext } from 'react-hook-form';

import CustomFormControl, {
  CustomFormControlProps,
} from '../custom-form-control';
import { BaseElementInputProps } from '../field-type';
import { FormContext } from '../form';
import PhoneInput, { PhoneInputProps } from '../master/phone-number-input';

export interface PhoneNumberInputProps
  extends BaseElementInputProps,
    Omit<
      CustomFormControlProps,
      'name' | 'overrides' | 'positive' | 'error' | 'children'
    >,
    Omit<
      PhoneInputProps,
      | 'name'
      | 'disabled'
      | 'required'
      | 'text'
      | 'onTextChange'
      | 'country'
      | 'onCountryChange'
    > {
  type: 'phone';
  prefixName: string;
  onAfterTextChange?: (val?: string) => void;
  onAfterCountryChange?: (dialCode?: string) => void;
}

export default function PhoneNumberInput(props: PhoneNumberInputProps) {
  const {
    readOnly,
    prefixName,
    required,
    hideLabel,
    name,
    label,
    disabled,
    onAfterCountryChange,
    onAfterTextChange,
    ...rest
  } = props;
  const { control } = useFormContext<any>();
  const { field: prefixField } = useController({ control, name: prefixName });
  const { field, fieldState } = useController({ control, name: props.name });

  const context = React.useContext(FormContext);

  const shouldShowError = !!fieldState.error?.message;

  const _disabled = !context.editable || readOnly;

  return (
    <CustomFormControl
      required={required}
      hideLabel={hideLabel}
      label={label}
      error={fieldState.error?.message}
    >
      <PhoneInput
        {...rest}
        disabled={_disabled}
        error={shouldShowError}
        country={prefixField.value}
        onCountryChange={(dialCode) => {
          prefixField.onChange(dialCode);
          prefixField.onBlur();
          onAfterCountryChange?.(dialCode);
          field.onBlur();
        }}
        text={field.value}
        onTextChange={(e) => {
          field.onChange(e);
          onAfterTextChange?.(e.currentTarget.value);
          field.onBlur();
        }}
      />
    </CustomFormControl>
  );
}
